import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const deleteChargeInstance = async ({
    token,
    charge_instance_id
}) => {

    try {
        const res = await axiosCreate.delete('/charge/instance/status/delete', {
            data: {
                charge_instance_id
            },
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}